import { Box, Button, Divider, FormControl, Grid, IconButton, InputLabel, MenuItem, MenuList, Modal, Pagination, Popover, Select, Table, TableBody, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useEffect, useState, useCallback } from "react";
import { Search, SearchIconWrapper, style, StyledInputBase, StyledTableCell, StyledTableRow } from "../../../styles/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { BsSearch } from "react-icons/bs";
import { useGetLessonSessionsQuery, useGetClassAndSubjectTeacherQuery } from "../../../api/lessonNoteApi";
import { toast } from "react-toastify";
import api from "../../../services/QualityAssurance";
import { useSelector } from "react-redux";
import TableLoader from "../../TableLoader";
import { ManualTable } from "./ManualTable";
import { PreviewTimetable } from "./PreviewTimeTable";

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '95%',
  // maxWidth: '1000px',
  bgcolor: 'white',
  boxShadow: 24,
  borderRadius: 2,
  p: 3,
};


export const SetUpTable = () => {
  const { admToken, user } = useSelector((state) => state.auth);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openManuaulModal, setOpenManualModal] = useState(false);
  const [openPreviewModal, setOpenPreviewModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [data, setData] = useState([]);
  const [editData, setEditData] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [pagination, setPagination] = useState({
    pageNumber: 1,
    pageSize: 10,
    totalRecords: 0,
    totalPages: 0
  });

  const [selectedSession, setSelectedSession] = useState({
    sessionId: 0,
    sessionName: ''
  });

  const [selectedClasses, setSelectedClasses] = useState({
    classId: 0,
    className: ''
  });

  const [schoolYear, setSchoolYear] = useState({
    sessionId: 0,
    sessionName: ''
  });
  const [classes, setClasses] = useState({
    classId: 0,
    className: ''
  });

  const { data: sessions, isLoading: sessionsLoading } = useGetLessonSessionsQuery();
  const { data: classAndArm, isLoading } = useGetClassAndSubjectTeacherQuery(user ? user.schoolId : 0);
  const tableData = data || [];

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false)
  const handleOpenManualModal = () => setOpenManualModal(true);
  const handleCloseManualModal = () => setOpenManualModal(false)
  const handleOpenPreviewModal = () => setOpenPreviewModal(true);
  const handleClosePreviewModal = () => setOpenPreviewModal(false);
  const handleCloseDeleteModal = () => setOpenDeleteModal(false);
  const handleOpenDeleteModal = () => setOpenDeleteModal(true);

  const handleClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setSelectedItem(item);
    setSelectedItemId(item.setupId);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    handleClose();
    handleOpenModal();
  };

  const fetchEditData = async (selelectedSetup) => {
    if (!selelectedSetup) return;
    setEditLoading(true);
    try {
      const res = await api.getTimeTableSetup(admToken, selelectedSetup);
      if (res.status && res.statusCode === 2) {
        setEditData(res.data);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setEditLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await api.getTimeTable(
        admToken,
        schoolYear.sessionId,
        classes.classId,
        searchText,
        pagination.pageSize,
        pagination.pageNumber,
      );
      if (res.status && res.statusCode === 2) {
        setData(res.data)
        setPagination(prev => ({
          ...prev,
          totalRecords: res.totalRecord,
          totalPages: Math.ceil(res.totalRecord / pagination.pageSize),
          currentPage: res.currentPage || 1
        }));
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    };
  }

  const handleUpdate = async () => {
    if (!editData?.setupId) return;

    setLoading(true);
    try {
      const payload = {
        sessionId:
          selectedSession.sessionId !== 0
            ? selectedSession.sessionId
            : editData.sessionId,
        classId:
          selectedClasses.classId !== 0
            ? selectedClasses.classId
            : editData.classId,
      };

      const res = await api.updateTimeTableSetup(admToken, editData?.setupId, payload);

      if (res.status && res.statusCode === 2) {
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message);
      }

      handleCloseModal();
    } catch (error) {
      console.error("Error updating TimeTable:", error);
    } finally {
      setLoading(false);
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    const selectedSession = sessions?.data?.find(s => s.id === value);
    setSchoolYear(prev => ({
      ...prev,
      [name]: value,
      sessionName: selectedSession ? selectedSession.name : ''
    }));
  };

  const handleChangeSelectedSession = (e) => {
    const { name, value } = e.target;
    const selectedSession = sessions?.data?.find(s => s.id === value);

    setSchoolYear(prev => ({
      ...prev,
      [name]: value,
      sessionName: selectedSession ? selectedSession.name : ''
    }));
  };

  const handleChangeClass = (e) => {
    const { name, value } = e.target;
    const selectedClass = classAndArm?.data?.find(s => s.id === value);
    setClasses(prev => ({
      ...prev,
      [name]: value,
      className: selectedClass ? selectedClass.name : ''
    }));
  };

  const handleChangeSelectedClass = (e) => {
    const { name, value } = e.target;
    const selectedClass = classAndArm?.data?.find(s => s.classId === value);

    setClasses(prev => ({
      ...prev,
      [name]: value,
      className: selectedClass
        ? `${selectedClass.className} ${selectedClass.classArm}`
        : ''
    }));
  };

  const handleStatusChange = async (status) => {
    if (!selectedItemId) return;

    try {
      const res = await api.updateTimeTableStatus(admToken, selectedItemId, status);
      if (res.status && res.statusCode === 2) {
        toast.success(res.data.message || res.message);
        fetchData();
        handleClose();
      } else {
        toast.error(res.data.message || res.message);
      }
    } catch (error) {
      console.error("Error updating Status:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
    setPagination(prev => ({ ...prev, pageNumber: 1 }));
  };

  const handlePageChange = (event, newPage) => {
    setPagination(prev => ({ ...prev, pageNumber: newPage }));
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    fetchData();
  };

  useEffect(() => {
    if (editData) {
      setSelectedSession({
        sessionId: editData.sessionId || 0,
        sessionName: editData.sessionName || '',
      });
      setSelectedClasses({
        classId: editData.classId || 0,
        className: editData.className || '',
      });
    }
  }, [editData]);

  const handleDelete = useCallback(async () => {
    try {
      if (!selectedItemId) return;
      const res = await api.deleteTimeTableSetup(admToken, selectedItemId);
      if (res.status && res.statusCode === 2) {
        toast.success(res.data.message || res.message);
        fetchData();
        handleCloseDeleteModal();
        handleClose();
      } else {
        toast.error(res.data.message || res.message);
      }
    } catch (error) {
      console.error(error);
    }
  }, [admToken, selectedItemId, fetchData]);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <div className="flex bg-[#691e78] px-3 py-3 gap-3 mb-5 rounded-lg">
        <FormControl fullWidth>
          <InputLabel
            sx={{
              mb: 1.5,
              mt: 1,
              fontSize: "22px",
              fontWeight: "bolder",
              color: "#fff",
              fontFamily: "Gilroy-Medium",
            }}
          >
            Session
          </InputLabel>
          <Select
            name="sessionId"
            sx={{
              fontFamily: "Gilroy-Regular",
              border: "0.5px solid #fff",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "1px solid #fff",
                },
              },
              color: "#fff",
            }}
            variant="outlined"
            size="small"
            value={schoolYear.sessionId}
            onChange={handleChange}
            disabled={sessionsLoading}
          >
            {sessionsLoading ? (
              <MenuItem disabled>Loading session...</MenuItem>
            ) : !sessions?.data || sessions.data.length === 0 ? (
              <MenuItem disabled>No session available</MenuItem>
            ) : (
              sessions.data.map((session) => (
                <MenuItem
                  sx={{ fontFamily: "Gilroy-Regular" }}
                  value={session.id}
                  key={session.id}
                >
                  {session.name}
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel
            sx={{
              mb: 1.5,
              mt: 1,
              fontSize: "22px",
              fontWeight: "bolder",
              color: "#fff",
              fontFamily: "Gilroy-Medium",
            }}
          >
            Class
          </InputLabel>
          <Select
            name="classId"
            sx={{
              fontFamily: "Gilroy-Regular",
              border: "0.5px solid #fff",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "1px solid #fff",
                },
              },
              color: "#fff",
            }}
            variant="outlined"
            size="small"
            value={classes.classId}
            onChange={handleChangeClass}
            disabled={isLoading}
          >
            {isLoading ? (
              <MenuItem disabled>Loading class...</MenuItem>
            ) : !classAndArm?.data || classAndArm.data.length === 0 ? (
              <MenuItem disabled>No session available</MenuItem>
            ) : (
              classAndArm.data.map((item) => (
                <MenuItem
                  sx={{ fontFamily: "Gilroy-Regular" }}
                  value={item.classId}
                  key={item.classId}
                >
                  {item.className} {item.classArm}
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>

        <button
          className="items-center text-[#691e78] bg-white flex justify-center px-8 py-1.5 rounded-sm"
          onClick={fetchData}
        >
          Load
        </button>
      </div>
      <div className="ring-1 ring-[#691e78] rounded-xl overflow-hidden">
        <Box>
          <Box
            sx={{
              pt: 4,
              background: "rgba(103, 30, 120, 0.1)",
              height: "100px",
              pl: { xs: 2.5 },
            }}
            onSubmit={handleSearchSubmit}
          >
            <Search
              sx={{
                width: {
                  lg: "345px",
                  md: "330px",
                  sm: "auto",
                  xs: "auto",
                  pl: { xs: 6 },
                },
              }}
            >
              <SearchIconWrapper>
                <BsSearch />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Search…"
                inputProps={{ "aria-label": "search" }}
                value={searchText}
                onChange={handleSearchChange}
              />
            </Search>
          </Box>
          <TableContainer>
            <Table
              sx={{
                minWidth: 700,
                fontFamily: "Gilroy-Regular",
                borderRadius: "0",
              }}
              aria-label="customized table"
            >
              <TableHead
                sx={{ backgroundColor: "rgba(103, 30, 120, 0.1)", width: "100%" }}
              >
                <TableRow>
                  <StyledTableCell>S/N</StyledTableCell>
                  <StyledTableCell>School Year</StyledTableCell>
                  <StyledTableCell>Class</StyledTableCell>
                  <StyledTableCell>Arm</StyledTableCell>
                  <StyledTableCell>Status</StyledTableCell>
                  <StyledTableCell></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody sx={{ fontFamily: "Gilroy-Regular", width: "100%" }}>
                {loading ? (
                  <StyledTableRow>
                    <StyledTableCell colSpan={6} align="center">
                      <TableLoader />
                    </StyledTableCell>
                  </StyledTableRow>
                ) : tableData.length > 0 ? (
                  tableData.map((item, index) => (
                    <StyledTableRow key={item.setupId || index}>
                      <StyledTableCell component="th" scope="row">{index + 1}</StyledTableCell>
                      <StyledTableCell>{item.session}</StyledTableCell>
                      <StyledTableCell>
                        {item.className} {item.classArm}
                      </StyledTableCell>
                      <StyledTableCell>{item.classArm}</StyledTableCell>
                      <StyledTableCell><span>{`${item.isActive === true ? "Activated" : "InActive"}`}</span></StyledTableCell>
                      <StyledTableCell>
                        <IconButton onClick={(e) => handleClick(e, item)}>
                          <MoreVertIcon />
                        </IconButton>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))
                ) : (
                  <StyledTableRow>
                    <StyledTableCell colSpan={6} align="center">
                      No activities found
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
            {pagination.totalPages > 1 && (
              <Box sx={{ display: "flex", justifyContent: "end", mt: 3, mb: 2 }}>
                <Pagination
                  count={pagination.totalPages}
                  page={pagination.currentPage}
                  onChange={handlePageChange}
                  color="primary"
                  sx={{
                    '& .MuiPaginationItem-root': {
                      color: '#671E78',
                    },
                    '& .Mui-selected': {
                      backgroundColor: 'rgba(103, 30, 120, 0.1)',
                    },
                  }}
                  showFirstButton
                  showLastButton
                />
              </Box>
            )}
          </TableContainer>
        </Box>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Box
            sx={{
              bgcolor: "#671E78",
              color: "#fff",
              fontFamily: "Gilroy-Regular",
              px: 3,
            }}
          >
            <MenuList sx={{ fontFamily: "Gilroy-Regular" }}>
              <MenuItem
                onClick={() => {
                  const newStatus = selectedItem?.isActive === false ? true : false;
                  handleStatusChange(newStatus);
                }}
              >
                {selectedItem?.isActive === false ? "Activate" : "Deactivate"}
              </MenuItem>

              <MenuItem
                onClick={() => {
                  handleEdit();
                  fetchEditData(selectedItem?.setupId);
                }}
              >
                Edit
              </MenuItem>
              <MenuItem
                onClick={handleOpenManualModal}
              >
                Manually Generate
              </MenuItem>
              <MenuItem
                onClick={handleOpenPreviewModal}
              >
                Preview
              </MenuItem>
              <MenuItem
                onClick={() => {
                  if (selectedItem) {
                    handleClose();
                    handleOpenDeleteModal();
                  }
                }}
              >
                Delete
              </MenuItem>
            </MenuList>
          </Box>
        </Popover>
        {/* Manual time Table */}
        <Modal
          open={openManuaulModal}
          onClose={handleCloseManualModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={modalStyle}>
            <Box align="right" sx={{}}>
              <IconButton onClick={handleCloseManualModal}>
                <HighlightOffIcon />
              </IconButton>
            </Box>
            <Box>
              <Typography
                variant="h4"
                sx={{ textAlign: "center", mb: 2, fontFamily: "Gilroy-Medium" }}
              >
                Edit School TimeTable
              </Typography>
              <Divider />
            </Box>
            <Box p={3} sx={{ overflowY: "scroll", height: "450px" }}>
              <ManualTable setupId={selectedItemId} />
            </Box>
          </Box>
        </Modal>
        {/* preview timetable */}
        <Modal
          open={openPreviewModal}
          onClose={handleClosePreviewModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={modalStyle}>
            <Box align="right" sx={{}}>
              <IconButton onClick={handleClosePreviewModal}>
                <HighlightOffIcon />
              </IconButton>
            </Box>
            <Box p={3} sx={{ overflowY: "scroll", height: "450px" }}>
              <PreviewTimetable sessionId={schoolYear.sessionId} classId={classes.classId} />
            </Box>
          </Box>
        </Modal>
        {/* edit */}
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Box align="right" sx={{}}>
              <IconButton onClick={handleCloseModal}>
                <HighlightOffIcon />
              </IconButton>
            </Box>
            <Box>
              <Typography
                variant="h4"
                sx={{ textAlign: "center", mb: 2, fontFamily: "Gilroy-Medium" }}
              >
                Edit TimeTable
              </Typography>
              <Divider />
            </Box>
            <Box p={3} sx={{ overflowY: "scroll", height: "450px" }}>
              <Grid container spacing={2}>
                <Grid item sm={6} xs={12}>
                  <Box>
                    <InputLabel
                      sx={{
                        mb: 1.5,
                        mt: 1,
                        fontSize: "12px",
                        fontWeight: "bolder",
                        color: "#000",
                        fontFamily: "Gilroy-Medium",
                      }}
                    >
                      School Year
                    </InputLabel>
                    <FormControl fullWidth>
                      <Select
                        name="sessionId"
                        sx={{
                          fontFamily: "Gilroy-Regular",
                          border: "0.5px solid #671E78",
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              border: "1px solid #671E78",
                            },
                          },
                        }}
                        variant="outlined"
                        size="small"
                        value={schoolYear.sessionId}
                        onChange={handleChangeSelectedSession}
                        disabled={editLoading || sessionsLoading}
                      >
                        {editLoading || sessionsLoading ? (
                          <MenuItem disabled>Loading session...</MenuItem>
                        ) : !sessions?.data || sessions.data.length === 0 ? (
                          <MenuItem disabled>No session available</MenuItem>
                        ) : (
                          sessions.data.map((session) => (
                            <MenuItem
                              sx={{ fontFamily: "Gilroy-Regular" }}
                              value={session.id}
                              key={session.id}
                            >
                              {session.name}
                            </MenuItem>
                          ))
                        )}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Box>
                    <InputLabel
                      sx={{
                        mb: 1.5,
                        mt: 1,
                        fontSize: "12px",
                        fontWeight: "bolder",
                        color: "#000",
                        fontFamily: "Gilroy-Medium",
                      }}
                    >
                      Class
                    </InputLabel>
                    <FormControl fullWidth>
                      <Select
                        name="classId"
                        sx={{
                          fontFamily: "Gilroy-Regular",
                          border: "0.5px solid #fff",
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              border: "1px solid #fff",
                            },
                          },
                        }}
                        variant="outlined"
                        size="small"
                        value={classes.classId}
                        onChange={handleChangeSelectedClass}
                        disabled={editLoading || isLoading}
                      >
                        {editLoading || isLoading ? (
                          <MenuItem disabled>Loading class...</MenuItem>
                        ) : !classAndArm?.data || classAndArm.data.length === 0 ? (
                          <MenuItem disabled>No session available</MenuItem>
                        ) : (
                          classAndArm.data.map((item) => (
                            <MenuItem
                              sx={{ fontFamily: "Gilroy-Regular" }}
                              value={item.classId}
                              key={item.classId}
                            >
                              {item.className} {item.classArm}
                            </MenuItem>
                          ))
                        )}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
              </Grid>
              <Box mt={10}>
                <Button
                  variant="contained"
                  fullWidth
                  sx={{ textTransform: "initial", backgroundColor: "#691e78" }}
                  onClick={handleUpdate}
                  disabled={editLoading || loading}
                >
                  {loading ? "Updating..." : "Edit TimeTable"}
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>
        {/* Delete */}
        <Modal
          open={openDeleteModal}
          onClose={handleCloseDeleteModal}
          aria-labelledby="delete-confirmation-modal"
        >
          <Box sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: "10px",
            boxShadow: 24,
            p: 4,
          }}>
            <Typography variant="h6" sx={{ fontFamily: "Gilroy-Medium", mb: 2 }}>
              Confirm Delete
            </Typography>
            <Typography variant="body1" sx={{ fontFamily: "Gilroy-Regular", mb: 3 }}>
              Are you sure you want to delete this?
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
              <Button
                variant="outlined"
                onClick={handleCloseDeleteModal}
                sx={{ textTransform: 'initial', fontFamily: "Gilroy-Regular" }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleDelete}
                sx={{
                  textTransform: 'initial',
                  fontFamily: "Gilroy-Regular",
                  bgcolor: '#671E78',
                  '&:hover': { bgcolor: '#4e165a' }
                }}
              >
                Delete
              </Button>
            </Box>
          </Box>
        </Modal>
      </div>
    </div>
  );
};